import { z } from 'zod';
import {
  CreateEfectivoMovimientoRequestSchema,
  CreateTransferenciaRequestSchema,
  EfectivoCentralMovimientoListQuerySchema,
  EfectivoCentralMovimientoSchema,
  EfectivoCentralSchema,
  EfectivoMovimientoListQuerySchema,
  EfectivoMovimientoSchema,
  EfectivoSaldoSchema,
  TransferenciaListQuerySchema,
  TransferenciaSchema,
  UpdateEfectivoMovimientoRequestSchema,
} from '@visep/shared-types/efectivo';
import type {
  CreateTransferenciaRequest,
  EfectivoCentral,
  EfectivoCentralMovimiento,
  EfectivoCentralMovimientoListQuery,
  EfectivoSaldo,
  Transferencia,
} from '@visep/shared-types/efectivo';
import type { Helpers, ListResult } from './internal.js';
import { listResultSchema, makeCrudResource, toQuery } from './internal.js';

export function createEfectivoResource({ request }: Helpers) {
  const movimientos = makeCrudResource(request, {
    basePath: '/api/efectivo/movimientos',
    schema: EfectivoMovimientoSchema,
    listQuerySchema: EfectivoMovimientoListQuerySchema,
    createSchema: CreateEfectivoMovimientoRequestSchema,
    updateSchema: UpdateEfectivoMovimientoRequestSchema,
  });
  const transferencias = makeCrudResource(request, {
    basePath: '/api/efectivo/transferencias',
    schema: TransferenciaSchema,
    listQuerySchema: TransferenciaListQuerySchema,
    createSchema: CreateTransferenciaRequestSchema,
    updateSchema: z.never(),
  });
  return {
    async getSaldo(): Promise<EfectivoSaldo> {
      return EfectivoSaldoSchema.parse(await request('GET', '/api/efectivo/saldo'));
    },
    listMovimientos: movimientos.list,
    getMovimiento: movimientos.get,
    createMovimiento: movimientos.create,
    updateMovimiento: movimientos.update,
    deleteMovimiento: movimientos.delete,
    async createTransferencia(input: CreateTransferenciaRequest): Promise<Transferencia> {
      const parsed = CreateTransferenciaRequestSchema.parse(input);
      return TransferenciaSchema.parse(await request('POST', '/api/efectivo/transferencias', parsed));
    },
    listTransferencias: transferencias.list,
    async getCentral(): Promise<EfectivoCentral> {
      return EfectivoCentralSchema.parse(await request('GET', '/api/efectivo/central'));
    },
    async listCentralMovimientos(
      query?: EfectivoCentralMovimientoListQuery,
    ): Promise<ListResult<EfectivoCentralMovimiento>> {
      const parsed = EfectivoCentralMovimientoListQuerySchema.parse(query ?? {});
      return listResultSchema(EfectivoCentralMovimientoSchema).parse(
        await request('GET', `/api/efectivo/central/movimientos${toQuery(parsed)}`),
      );
    },
  };
}
